module.exports = __webpack_public_path__ + "img/1F634.d817215d.svg";